import { useEffect, useContext } from 'react';
import { useDispatch } from "react-redux";
import { setNotifications } from "../features/notificationsSlice";
import { NotificationContext } from "../context/NotificationContext";

export default function useNotification() {
    const dispatch = useDispatch();
    const { state: notificationState } = useContext(NotificationContext);
    const notifications = notificationState.notifications; // ✅ 取得通知

    useEffect(() => {
        dispatch(setNotifications(notifications)); // ✅ 確保 Redux 更新最新的通知
    }, [dispatch, notifications]); // ✅ 加入 `notifications`，讓 Redux 追蹤最新狀態

    return null; // ✅ 不需要回傳值，因為 Redux 已管理通知
};
